export default __webpack_public_path__ + "static/media/bluetoothcontroller.6f511445.png";